import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheckCircle, faExclamationTriangle, faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

// Advisory CRM cross-check flags for a received invoice (identity / bank
// account / bank owner / KYC status). Purely informational — never blocks
// saving or approval; the person approving the payment decides.
//
// checks: [{check, status: 'match'|'mismatch'|'warning'|'skipped', detail}]
// overall: 'ok' | 'warning' | 'mismatch'

const CHECK_LABELS = {
    identity: 'Supplier identity',
    bank_account: 'Bank account (IBAN)',
    bank_owner: 'Payment account owner',
    kyc_status: 'KYC status',
};

const CrmMatchFlags = ({ checks, overall }) => {
    if (!Array.isArray(checks) || checks.length === 0) return null;
    // Nothing could be checked at all -> stay silent rather than imply a verdict
    if (checks.every(c => c.status === 'skipped')) return null;

    const problems = checks.filter(c => c.status === 'mismatch' || c.status === 'warning');
    const isOk = overall === 'ok';

    const palette = overall === 'mismatch'
        ? { bg: '#fef2f2', border: '#dc2626', text: '#991b1b', icon: faTimesCircle }
        : overall === 'warning'
            ? { bg: '#fffbeb', border: '#d97706', text: '#92400e', icon: faExclamationTriangle }
            : { bg: '#f0fdf4', border: '#16a34a', text: '#166534', icon: faCheckCircle };

    return (
        <div style={{
            background: palette.bg,
            border: `1px solid ${palette.border}`,
            borderLeft: `4px solid ${palette.border}`,
            borderRadius: '8px',
            padding: '0.75rem 1rem',
            margin: '0 0 1rem 0',
            color: palette.text,
            fontSize: '0.875rem',
        }}>
            <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FontAwesomeIcon icon={palette.icon} />
                {isOk
                    ? 'CRM check: invoice matches the partner\'s CRM records.'
                    : 'CRM check: this invoice does not fully match CRM records.'}
            </div>
            {!isOk && (
                <ul style={{ margin: '0.5rem 0 0 0', paddingLeft: '1.5rem' }}>
                    {problems.map((c) => (
                        <li key={c.check} style={{ marginBottom: '0.25rem' }}>
                            <strong>{CHECK_LABELS[c.check] || c.check}:</strong> {c.detail}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CrmMatchFlags;
